import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import useRoutes from 'routes';

// Chakra imports
import { Box, useColorModeValue } from '@chakra-ui/react';

// Layout components
import { SidebarContext } from 'contexts/SidebarContext';
// Auth pages
import SignIn from 'views/auth/signIn/SignIn';
import SignUp from 'views/auth/signUp/SignUp';
import ForgotPassword from 'views/auth/forgotPassword/ForgotPassword';
import Verification from 'views/auth/verification/VerificationCenter';
import NewPassword from 'views/auth/newpassword/NewpaswordCenter';

// Custom Chakra theme
export default function Auth() {
  const routes = useRoutes()
  // states and functions
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const getRoute = () => {
    return window.location.pathname !== '/auth/full-screen-maps';
  };
  // const getRoutes = (routes: RoutesType[]): any => {
  //   return routes.map((route, key) => {
  //     if (route.layout === '/auth') {
  //       return (
  //         <Route path={`${route.path}`} element={route.component} key={key} />
  //       );
  //     }
  //     if (route.collapse) {
  //       return getRoutes(route.items);
  //     }
    const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route, key) => {
      // Recursively handle collapse routes first (if any)
      if (route.collapse && route.items) {
        return getRoutes(route.items);
      }

      // Then handle /auth layout routes
      if (route.layout === '/auth') {
        return (
          <Route path={route.path} element={route.component} key={key} />
        );
      }
      return null;
    });
  };
  const authBg = useColorModeValue('background.100', 'background.900');
  document.documentElement.dir = 'ltr';
  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Box
          bg={authBg}
          float="right"
          minHeight="100vh"
          height="100%"
          position="relative"
          w="100%"
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          {getRoute() ? (
            <Box mx="auto" minH="100vh">
              <Routes>
                {getRoutes(routes)}
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/verification" element={<Verification />} /> 
              <Route path="/new-password" element={<NewPassword />} />
              <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
              </Routes>
            </Box>
          ) : null}
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
